import React from "react"

const Footer = () => 
<footer className="footer font-small blue pt-4">
    

    <div className="footer-copyright text-center py-3">© 2025 Copyright:
        <a> Javier Ruiz Sanchez</a>
    </div>

</footer>

export default Footer;